import { z } from 'zod';
import { groupTypeSchema } from '../enums/group.js';
import { RefPermission, RefRole } from '../enums/permission.js';
import { makeFilteredArraySchema } from '../utils/zod.js';
import { productBrandIndicationNamedSchema } from './product-brand-indications.js';

export const userMetadataSchema = z.record(z.string(), z.unknown());

export const USER_METADATA_FRM_GROUP_KEY = 'frmGroup' as const;

export const frmGroupSchema = z.enum(['frm', 'nfrm', 'frmd']);
export type FrmGroup = z.infer<typeof frmGroupSchema>;

export const frmGroupLabelMap: Record<FrmGroup, string> = {
  frm: 'FRM Users',
  nfrm: 'Non FRMs',
  frmd: 'Directors/ Associate Directors',
};

export const userBrandIndicationSchema = productBrandIndicationNamedSchema.pick({
  productBrandName: true,
  indicationName: true,
  isDefault: true,
});

export const userBrandIndicationsSchema = z.array(userBrandIndicationSchema);

export const UserDetailsUserModel = z.object({
  enabled: z.boolean(),
  id: z.coerce.number(),
  identifier: z.string(),
  username: z.string(),
  email: z.string(),
  name: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
});
const UserDetailsGroupModel = z.object({
  id: z.coerce.number(),
  identifier: z.string(),
  name: z.string(),
  typeId: groupTypeSchema,
});

export const UserDetailsModel = UserDetailsUserModel.extend({
  group: UserDetailsGroupModel,
  permissions: makeFilteredArraySchema(RefPermission),
  photoUrl: z.string().nullable().optional(),
  roles: z.array(RefRole),
  metadata: userMetadataSchema.default({}),
  brandIndications: userBrandIndicationsSchema.default([]),
});
export type UserDetails = z.infer<typeof UserDetailsModel>;

export const UserAuditSchema = z.object({
  id: z.coerce.number(),
  name: z.string().nullable(),
  email: z.email().nullable(),
});

export type UserAudit = z.infer<typeof UserAuditSchema>;
